import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { useApi } from "@/hooks";

import { TvQueryKeys } from "../query-keys";

function getRefetchInterval() {
  const min = 145000;
  const max = 161000;

  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function useTvChannelPing(
  id: number,
  { delay = 0, isEnabled }: { delay?: number; isEnabled: boolean },
) {
  const api = useApi();

  const [refetchInterval, setRefetchInterval] =
    useState<number>(getRefetchInterval());

  async function pingChannel() {
    const { data } = await api.post<{ url: string }>(
      `/api/v1/tv/client/ping/${id}`,
      {
        delay,
      },
    );
    return data;
  }

  const queryInfo = useQuery({
    queryKey: TvQueryKeys.channelPing(id),
    queryFn: pingChannel,
    refetchInterval,
    refetchIntervalInBackground: true,
    retry: 1,
    enabled: isEnabled,
  });

  useEffect(() => {
    if (queryInfo.isSuccess && queryInfo.data) {
      setRefetchInterval(getRefetchInterval());
    }
  }, [queryInfo.isSuccess, queryInfo.data]);

  return queryInfo;
}

export { useTvChannelPing };
